import {CartValidation} from '@bitstillery/common/api/fact2server'
import {present} from '@bitstillery/common/lib/utils'

import type {StatePortal} from '@/lib/state'
import type {CartOfferItem} from '@/models/cart'
import {$s} from '@/app'

export const DISCOUNT_TYPES = ['offer', 'spotlight']

export function offer_item_price(
    offer_item: Pick<
        CartOfferItem,
        'case_artkey' | 'case_number_of_bottles' | 'list_price' | 'offer_type' | 'original_price_per_case'
    > & {
        // Filled in with 0 below when the offer item has none.
        excise_per_case?: string | number | null
    },
    errors: Partial<StatePortal['cart']['errors']> | undefined,
) {
    // The current price that users see as the regular price.
    let current = Number(offer_item.list_price)

    const has_discount = DISCOUNT_TYPES.includes(offer_item.offer_type)
    let previous = Number(offer_item.original_price_per_case)
    const list_price = Number(offer_item.list_price)

    let is_invalid = false
    let is_down = false
    let is_up = false

    const priceRaisedErrors = errors?.[CartValidation.PRICE_WAS_RAISED]
    if (priceRaisedErrors && offer_item.case_artkey in priceRaisedErrors) {
        // We don't show raised prices, unless it comes from a
        // Price_up validation issue.
        is_up = true
        is_invalid = true
        previous = present(priceRaisedErrors[offer_item.case_artkey], 'price raised error').invalid_value
        current = present(priceRaisedErrors[offer_item.case_artkey], 'price raised error').valid_value
    } else if (list_price < previous) {
        is_down = true
    }

    let excise = Number((offer_item.excise_per_case ??= 0))
    const case_bottles = offer_item.case_number_of_bottles

    if ($s.cart.show_bottles) {
        excise /= case_bottles
        current /= case_bottles
        previous /= case_bottles
    }

    return {case_bottles, current, excise, has_discount, is_down, is_invalid, is_up, previous}
}

export type OfferItemPrice = ReturnType<typeof offer_item_price>
